<template>
    <div>
        <button v-if="linkType == 'button'" class="btn btn-light" type="submit" v-b-modal="'detail-help' + uid" v-shortkey="{openHelpModel: ['F1']}" @shortkey="keyDown">
            <em class="fas fa-question-circle"></em> Help
        </button>

        <a v-else class="force" v-b-modal="'detail-help' + uid" v-shortkey="{openHelpModel: ['F1']}" @shortkey="keyDown">Help</a>

        <b-modal
                @shown="show"
                @hidden="$root.modelOpen = false"
                :no-close-on-backdrop="false"
                :lazy="true"
                :ref="'detail-help' + uid"
                :id="'detail-help' + uid"
                title="Help"
                size="lg">
            <div>
                <p>Er zijn in verschillende schermen diverse sneltoetsen beschikbaar om zo zeer efficient te werken en navigeren. Op Mac computers kan ook de <b-badge>Cmd</b-badge> toets gebruikt worden in plaats van de <b-badge>Ctrl</b-badge> toets.</p>
                <b-table small :items="shortcuts" :fields="fields">
                    <template v-slot:cell(shortcut)="data">
                        <span v-for="(key, index) in data.value.split('+')" :key="key"><b-badge>{{key}}</b-badge>&nbsp;<span v-if="index < data.value.split('+').length - 1" class="fas fa-plus"></span>&nbsp;</span>
                    </template>

                    <template v-slot:cell(description)="data">
                        <span v-html="data.value"></span>
                    </template>
                </b-table>
            </div>
            <div slot="modal-footer" class="w-100">
                <button class="btn btn-light float-right" @click="hide">
                    Sluiten
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                fields: [
                    {shortcut: {
                        label: 'Sneltoets (combinatie)',
                        sortable: false
                    }},
                    {description: {
                        label: 'Actie',
                        sortable: false
                    }}
                ],
                shortcuts: [
                    { shortcut: 'ESC', description: 'Sluit pop-up (indien geopend)' },
                    { shortcut: 'ESC', description: 'Sluit de lead (indien geen pop-up geopend)' },
                    { shortcut: 'Ctrl+ESC', description: 'Sluit de lead en markeert deze als ongelezen' },
                    { shortcut: 'Ctrl+S', description: 'Lead opslaan' },
                    { shortcut: 'T', description: 'Open de pop-up om persoon <u><b>t</b></u>oe te wijzen' },
                    { shortcut: 'A', description: 'Open de pop-up met <u><b>a</b></u>lle velden van het ontvangen formulier' },
                    { shortcut: 'O', description: 'Open de pop-up om een <u><b>o</b></u>rganisatie te selecteren' },
                    { shortcut: 'C', description: 'Navigeer naar het formulier om een <u><b>c</b></u>ontactmoment te registreren' },
                    { shortcut: 'P', description: 'Open de pop-up om een contact<u><b>p</b></u>ersoon te selecteren' }
                ]
            }
        },
        props: {
            linkType: {
                type: String,
                required: false
            },
            uid: {
                type: String,
                required: true
            }
        },
        methods: {
            hide() {
                this.$refs['detail-help' + this.uid].hide();
            },
            show(model) {
                this.$root.modelOpen = model.target.id;
            },
            keyDown(event) {
                switch (event.srcKey) {
                    case 'openHelpModel':
                        this.$refs['form-view-company'].show();
                    break;
                }
            }
        }
    }
</script>

<style lang="scss">
    span.fas {
        font-size: 11px;
        color: #adadad;
    }
</style>